var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceivedAlarms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recieved Alarms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-1223.000000, -361.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recieved-Alarms",
    transform: "translate(1223.000000, 361.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0 C6.92075,0 4.541,1.03455 2.7911,2.7911 L0.95,0.95 L0.95,6.65 L6.65,6.65 L4.13345,4.13345 C5.5328,2.72745 7.4366,1.9 9.5,1.9 C13.69045,1.9 17.1,5.30955 17.1,9.5 L19,9.5 C19,4.2617 14.7383,0 9.5,0",
    id: "Fill-1964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.05,12.35 L12.35,12.35 L14.86655,14.86655 C13.4672,16.27255 11.56435,17.1 9.5,17.1 C5.30955,17.1 1.9,13.69045 1.9,9.5 L0,9.5 C0,14.7383 4.2617,19 9.5,19 C12.0802,19 14.45995,17.96545 16.2089,16.2089 L18.05,18.05 L18.05,12.35 Z",
    id: "Fill-1965"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1966",
    points: "10.45 10.45 8.55 10.45 8.55 4.75 10.45 4.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6875,13.3 C10.6875,13.9555 10.1555,14.4875 9.5,14.4875 C8.8445,14.4875 8.3125,13.9555 8.3125,13.3 C8.3125,12.6445 8.8445,12.1125 9.5,12.1125 C10.1555,12.1125 10.6875,12.6445 10.6875,13.3",
    id: "Fill-1967"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedAlarms);
export default __webpack_public_path__ + "static/media/receivedAlarms.67fd9db02b16031f236b3757329025d8.svg";
export { ForwardRef as ReactComponent };